const DAYS_TO_END = 7;
const DAYS_TO_START = 7;

const STATUS_TYPES = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    PENDING: 'PENDING',
    EXPIRED: 'EXPIRED',
};

const ret = {
    STATUS: {
        DEFAULT: 'Active',
        TYPES: STATUS_TYPES,
        ITEMS: [
            {
                id: 1,
                value: STATUS_TYPES.ACTIVE,
                i18nKey: '_common:entities.hotelPriceRulesStatus.items.active',
            },
            {
                id: 2,
                value: STATUS_TYPES.INACTIVE,
                i18nKey: '_common:entities.hotelPriceRulesStatus.items.inactive',
            },
            {
                id: 3,
                value: STATUS_TYPES.PENDING,
                i18nKey: '_common:entities.hotelPriceRulesStatus.items.pending',
            },
            {
                id: 4,
                value: STATUS_TYPES.EXPIRED,
                i18nKey: '_common:entities.hotelPriceRulesStatus.items.expired',
            },
        ],
    },
    DAYS_TO_END,
    DAYS_TO_START,
};

export default ret;
